import script from "./SchoolSignup.vue?vue&type=script&setup=true&lang=js"
export * from "./SchoolSignup.vue?vue&type=script&setup=true&lang=js"

import "./SchoolSignup.vue?vue&type=style&index=0&id=d4397616&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\lms-alternates\\vue-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d4397616"]])

export default __exports__